import React from 'react';
import { ReactComponent as Logo } from '../Images/logo-white.svg';
import {Link} from 'react-router-dom';

export const Footer = () => {
  return (
    <>
      <div className='bg-[#0e719c]'>
          <div className="flex flex-row justify-around">
              <div>
                  <p className='text-white pt-10'>Company</p>
                  <Link to='/about' className='text-white text-sm '>About</Link>
              </div>
              <div>
                  <p className='text-white pt-10'>Support</p>
                  <a href="https://docs.google.com/forms/d/e/1FAIpQLSeLPj-WBpfdCgArkUuAJ9keDdUvKvR5NXQj3aJTl-IfbOESNg/viewform?usp=send_form" className='text-white text-sm '>Contact</a>
              </div>
          </div>
          <div className='px-28'>
            <div className='flex justify-center items-center'>
              <Logo className='w-44 mt-10'/>
            </div>
            <p className='pt-1 text-center text-white font-light text-sm'>©2022, SpendVest Inc.</p>
            <p className='text-white font-light text-center text-sm'>All rights Reserved</p>  
          </div>
          <div className='flex flex-row justify-center items-center'>
            <pre className='text-center py-6 text-white text-sm'>Developed with ❤️ by </pre>
            <a className='text-center py-6 text-white text-sm' href="https://pranavmujumdar.hashnode.dev/" target='_blank' rel='noreferrer'><p>Pranav Mujumdar</p></a>
          </div>
      </div>
    </>
  )
}